import { render, staticRenderFns } from "./v-contact-widget-icon.vue?vue&type=template&id=22fd3f45&scoped=true&"
var script = {}
import style0 from "./v-contact-widget-icon.vue?vue&type=style&index=0&id=22fd3f45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd3f45",
  null
  
)

export default component.exports